import React from 'react';
import Brick from './Brick';
import { Redirect } from "react-router-dom";
import { Utils } from '../../services';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * redirect the user
 */
class RedirectBrick extends Brick {
    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t } = props;
        return (
            <FormGroup row>
                <Label for="form_id" className="text-v-center" sm={4}>
                    { t('workflows.bricks.redirect.options.url') }
                </Label>
                <Col sm={8}>
                    <Field component="input" type="text" name={`bricks[${this.position}].options.url`} className="form-control" />
                </Col>
            </FormGroup>
        );
    }

    run(context, onDone) {
        let url = this.getOption('url');
        url = Utils.replaceShortcodes(url, context);

        onDone(context, (err, workflow) => {
            window.location.href = url;
        });

        return null;
    }
}

export default RedirectBrick;
